"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doubleMetricCardTranslations = {
    "en": {
        totalCalls: "Total calls",
        rolledCalls: "Rolled calls",
    },
    "de": {
        totalCalls: "Gesamtzahl der Anrufe",
        rolledCalls: "Umgeleitete Gespräche",
    },
    "nl": {
        totalCalls: "Totale oproepen",
        rolledCalls: "Doorgegeven oproepen",
    },
    "it": {
        totalCalls: "Chiamate totali",
        rolledCalls: "Chiamate inoltrate",
    },
    "fr": {
        totalCalls: "Nombre total d'appels",
        rolledCalls: "Appels connectés",
    },
    "es": {
        totalCalls: "Total de llamadas",
        rolledCalls: "Llamadas trasladadas",
    },
    "ja": {
        totalCalls: "合計通話数",
        rolledCalls: "無応答転送通話",
    },
    "en-GB": {
        totalCalls: "Total calls",
        rolledCalls: "Rolled calls",
    },
    "ru": {
        totalCalls: "Всего звонков",
        rolledCalls: "Перенаправленные звонки",
    },
};
